<template>
  <div>
    <the-header></the-header>
    <main>
      <slot></slot>
    </main>
    <the-footer></the-footer>
    <the-mobile-menu class="sm:hidden"></the-mobile-menu>
  </div>
</template>
